import {
  Card,
  Chip,
  IconButton,
  Modal,
  Stack,
  Typography,
  Grid as Grid,
  Box,
  useTheme,
  useMediaQuery,
  List,
  ListItem,
  ListItemText,
  Button
} from "@mui/material";
import { ArrowUpward } from "@mui/icons-material";
import ErrorIcon from "@mui/icons-material/Error";
import DeleteIcon from "@mui/icons-material/Delete";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import moment from "moment";
import { useSelector } from "react-redux";
import { English } from "../../constant/EnglishFallback";
const MyPostingTutorial = (props) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const drawerWidth = 240;

  const { multiLanguageData } = useSelector((state) => state?.main);
  const LanguageData = multiLanguageData?.JobPostings || {};
  const {
    TEXT_EXPIRED_JOB_HEADER = English.JobPostings.TEXT_EXPIRED_JOB_HEADER,
    TEXT_DELETE = English.JobPostings.TEXT_DELETE,
    TEXT_REPOST = English.JobPostings.TEXT_REPOST,
    TEXT_USERS_ARE_ABLE_TO = English.JobPostings.TEXT_USERS_ARE_ABLE_TO,
    TEXT_ONCE_CREATED = English.JobPostings.TEXT_ONCE_CREATED,
    TEXT_JOB_POSTING_EXPIRE = English.JobPostings.TEXT_JOB_POSTING_EXPIRE
  } = LanguageData || {};

  const activeJobs = [
    {
      id: 5,
      siteId: 10015,
      siteName: "From this1",
      address: "",
      city: "",
      province: "",
      postalCode: "",
      country: "",
      latitude: 18.5394191,
      longitude: 73.8287488,
      projectId: 2964,
      projectName: "Calgary Cancer center",
      tradeId: 3,
      tradeName: "Cabinetmaker",
      companyId: 1052,
      companyName: "Thermal Systems",
      jobDuration: 2,
      jobDurationType: "Week(s)",
      email: "hr@thermalsystems.ca",
      jobPostExpiryDate: "2025-06-06T06:01:36.23",
      isExpired: true,
      description: "",
      recordStatusId: 1,
      recordStatus: "New",
      createdBy: 8,
      dateCreated: "2025-05-23T06:01:36.227",
      modifiedBy: 8,
      dateModified: "2025-05-23T06:01:36.227",
      createdByUser: "Tejashree Bhuse",
      modifiedByUser: "Tejashree Bhuse"
    }
  ];

  const getDate = (item) => {
    const expiryDate = moment(item?.jobPostExpiryDate);
    const currentDate = moment();
    const daysLeft = expiryDate.diff(currentDate, "days");
    return (
      <Box display={"flex"} flexDirection={"column"} alignItems={"flex-end"}>
        <Stack
          alignItems={{ xs: "flex-start", sm: "flex-end" }}
          direction={{ xs: "row-reverse", sm: "column" }}
          spacing={0.5}>
          <IconButton size="small" color="error">
            {" "}
            <ErrorIcon fontSize="small" />
          </IconButton>
          <Stack direction={{ xs: "column", sm: "row" }} spacing={1}>
            <Button startIcon={<DeleteIcon />} variant="outlined" color="secondary" size="small">
              {TEXT_DELETE}
            </Button>
            <Button startIcon={<AutorenewIcon />} variant="outlined" color="primary" size="small">
              {TEXT_REPOST}
            </Button>
          </Stack>
        </Stack>
      </Box>
    );
  };

  const renderJobList = (itemList) => {
    return itemList.map((item, index) => (
      <Card
        key={index.toString()}
        className="pagelist-content"
        sx={{ marginTop: "0px", padding: 0, cursor: "pointer" }}>
        <ListItem
          alignItems="flex-start"
          sx={{
            m: 0,
            ".MuiListItemSecondaryAction-root": {
              right: isSmallScreen ? 5 : 16
            }
          }}
          key={index.toString()}
          secondaryAction={getDate(item)}>
          <ListItemText
            sx={{ mt: 0, alignItems: "flex-start" }}
            primary={
              <Stack flexDirection={"row"} justifyContent={"space-between"}>
                <Typography variant="body1" sx={{ maxWidth: isSmallScreen ? 210 : 430 }} noWrap>
                  {item?.projectName}
                </Typography>
              </Stack>
            }
            secondary={
              <Stack gap={0.5}>
                <Stack>
                  <Typography variant="body2" sx={{ maxWidth: isSmallScreen ? 210 : 430 }} noWrap>
                    {item?.companyName}
                  </Typography>
                  <Typography variant="body2" sx={{ maxWidth: isSmallScreen ? 210 : 430 }} noWrap>
                    {item?.email}
                  </Typography>
                </Stack>
                <Stack spacing={1} direction={"row"} alignItems={"center"}>
                  <Chip
                    sx={{ fontSize: isSmallScreen ? "10px" : "14px" }}
                    size="small"
                    label={item?.tradeName}
                  />
                  {item?.jobDuration && item?.jobDurationType && (
                    <Chip
                      sx={{ fontSize: isSmallScreen ? "10px" : "14px" }}
                      size="small"
                      label={item?.jobDuration + " " + item?.jobDurationType.replace("(s)", "")}
                    />
                  )}
                </Stack>
                {item?.description !== "" && (
                  <Typography variant="body2" maxWidth={430} noWrap>
                    {item?.description}
                  </Typography>
                )}
              </Stack>
            }
          />
        </ListItem>
      </Card>
    ));
  };

  return (
    <Modal open={props?.tutorialIndex === 0 ? false : true}>
      <Box sx={{ backgroundColor: "rgba(0, 0, 0, 0.7)", height: "100%" }} onClick={props.onPress}>
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            height: `calc(100vh - ${theme.mixins.toolbar.minHeight}px)`, // Dynamically set height
            overflowY: "auto",
            mt: `${theme.mixins.toolbar.minHeight}px`, // Push content below AppBar
            width: { sm: props.tutorialIndex === 3 ? "100%" : `calc(100% - ${drawerWidth}px)` }, // Ensure content doesn't go behind Sidebar
            marginLeft: { sm: props.tutorialIndex === 3 ? 0 : `${drawerWidth}px`, xs: 0 }
          }}>
          <Box
            className="main-content-Box"
            sx={{ p: isSmallScreen ? 2 : 3, pt: 2, backgroundColor: "transparent" }}>
            <Card sx={{ p: 2, mt: { md: 11 } }}>
              <List disablePadding>
                <Typography p={1} pt={0} variant="h6">
                  {" "}
                  {TEXT_EXPIRED_JOB_HEADER}
                </Typography>
                <Stack gap={1}>{renderJobList(activeJobs)}</Stack>
              </List>
            </Card>
            <Stack
              sx={{
                backgroundColor: "transparent !important",
                display: "flex",
                alignItems: "center",
                pt: 2
              }}>
              <Stack
                sx={{
                  display: "flex",
                  alignItems: "center",
                  color: "white"
                }}>
                <ArrowUpward />
                <Typography variant="subtitle1" style={{ color: "white" }}>
                  {TEXT_USERS_ARE_ABLE_TO}
                </Typography>
                <Typography variant="subtitle1" style={{ color: "white" }}>
                  {TEXT_ONCE_CREATED}
                </Typography>
                <Typography variant="subtitle1" style={{ color: "white" }}>
                  {TEXT_JOB_POSTING_EXPIRE}
                </Typography>
              </Stack>
            </Stack>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default MyPostingTutorial;
